export default {
  masterChef: {
    97: '',
    // 137: '0x95d5aa8d80bBd9c1178DF312B4B742cbC66AA467',
    137: '0xfFFb1781422CC18Ab5786E3DBD55D7C91f9E5d9D',
  },
  sousChef: {
    97: '',
    // 137: '0x34b751908AFd59F48916A1Dfe048603628Fcf245',
    137: '0x38683555B7A7bA4C97204FC070bb4F1416d22dc4',
  },
  lottery: {
    97: '0x99c2EcD51d52c036B00130d882Bc65f20Fdecf9f',
    137: '0x3C3f2049cc17C136a604bE23cF7E42745edf3b91',
  },
  lotteryNFT: {
    97: '0x8175c10383511b3a1C68f9dB222dc14A19CC950e',
    137: '0x5e74094Cd416f55179DBd0E45b1a8ED030e396A1',
  },
  lotteryV2: {
    97: '0xc78819a896815310C1722774aFB1459c6B434FFC',
    137: '',
  },
  multiCall: {
    137: '0xD40e1Fa7FD7F6144af82161b7e1D3F6011B387e0',
    97: '',
  },
  pancakeProfile: {
    137: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
  },
  pancakeRabbits: {
    137: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
  },
  bunnyFactory: {
    137: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
  },
  claimRefund: {
    137: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '',
  },
  pointCenterIfo: {
    137: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
  },
  bunnySpecial: {
    137: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
  },
  tradingCompetition: {
    137: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
  },
  easterNft: {
    137: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
  },
  cakeVault: {
    // 137: '0xD54Dc79256fBA103939b1bddF28e7a9B2289F03C',
    137: '0xe3427702c18CB241521e255798aC570695BcecdA',
    97: '',
  },
  predictions: {
    137: '0x516ffd7D1e0Ca40b1879935B2De87cb20Fc1124b',
    97: '0x4f3140C74789F1D809420343ea83BcE52B7bbAA5',
  },
  chainlinkOracle: {
    137: '0x0567F2323251f0Aab15c8dFb1967E4e8A7D42aeE',
    97: '',
  },
  bunnySpecialCakeVault: {
    137: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '',
  },
  bunnySpecialPrediction: {
    137: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '',
  },
  referral: {
    // 137: '0xcfb0c79ed225e2da3b93e4b7e20df568874bf28d', 
    137: '0x4E4b149c226446f2d847A8809e7Ec931E1A4Dd6D',// referral
    97: '',
  },
}
